const getMathFact = (score) => {
    const facts = [
        `${score} in binary is ${score.toString(2)}. Binary is the language computers speak!`,
        `If you add all numbers from 1 to ${score}, you get ${(score * (score + 1)) / 2}.`,
        `${score} squared equals ${score * score}. That's a lot of math!`,
        `The digits of ${score} add up to ${String(score).split('').reduce((a, b) => a + parseInt(b), 0)}.`,
        `You answered ${score} problems correctly. Keep practicing!`,
        `Fun fact: ${score} × 2 = ${score * 2}, and ${score} × 10 = ${score * 10}!`,
    ];
    return facts[Math.floor(Math.random() * facts.length)];
};

const styles = {
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        gap: '20px',
        color: 'white',
        overflow: 'hidden',
    },
    header: {
        textAlign: 'center',
    },
    title: {
        fontSize: '24px',
        fontWeight: 700,
        margin: '0 0 4px 0',
    },
    scoreValue: {
        fontSize: '72px',
        fontWeight: 900,
        background: 'linear-gradient(180deg, #d8b4fe 0%, #7c3aed 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        margin: 0,
        lineHeight: 1,
    },
    scoreLabel: {
        color: '#94a3b8',
        fontWeight: 500,
        fontSize: '14px',
        margin: 0,
    },
    factCard: {
        width: '100%',
        maxWidth: '260px',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    factHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        marginBottom: '8px',
        color: '#34d399',
    },
    factLabel: {
        fontSize: '11px',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '1px',
    },
    factText: {
        fontSize: '13px',
        color: '#cbd5e1',
        lineHeight: 1.5,
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '12px',
        width: '100%',
        maxWidth: '260px',
    },
    statCard: {
        backgroundColor: 'rgba(30, 41, 59, 0.5)',
        padding: '10px',
        borderRadius: '10px',
        textAlign: 'center',
    },
    statLabel: {
        display: 'block',
        fontSize: '10px',
        color: '#64748b',
        textTransform: 'uppercase',
        fontWeight: 700,
        marginBottom: '2px',
    },
    statValue: {
        fontSize: '16px',
        fontFamily: 'monospace',
        fontWeight: 700,
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '260px',
        gap: '10px',
    },
    primaryButton: {
        width: '100%',
        padding: '14px',
        backgroundColor: 'white',
        color: '#1e293b',
        border: 'none',
        borderRadius: '12px',
        fontSize: '16px',
        fontWeight: 700,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
        transition: 'all 0.2s ease',
    },
    secondaryButton: {
        width: '100%',
        padding: '14px',
        backgroundColor: 'transparent',
        color: 'white',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '12px',
        fontSize: '16px',
        fontWeight: 700,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        transition: 'all 0.2s ease',
    },
};

export const GameOver = ({ score, maxRange, onRestart, onHome }) => {
    const fact = getMathFact(score);
    const difficulty = score > 20 ? 'Expert' : score > 10 ? 'Pro' : 'Novice';

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h2 style={styles.title}>Time's Up!</h2>
                <div style={styles.scoreValue}>{score}</div>
                <p style={styles.scoreLabel}>Final Score</p>
            </div>

            <div style={styles.factCard}>
                <div style={styles.factHeader}>
                    <span>✨</span>
                    <span style={styles.factLabel}>Fun Fact</span>
                </div>
                <div style={styles.factText}>{fact}</div>
            </div>

            <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                    <span style={styles.statLabel}>Max Range</span>
                    <span style={styles.statValue}>{maxRange}</span>
                </div>
                <div style={styles.statCard}>
                    <span style={styles.statLabel}>Difficulty</span>
                    <span style={styles.statValue}>{difficulty}</span>
                </div>
            </div>

            <div style={styles.buttonsContainer}>
                <button
                    onClick={onRestart}
                    style={styles.primaryButton}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e2e8f0'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'white'}
                >
                    🔄 Play Again
                </button>
                <button
                    onClick={onHome}
                    style={styles.secondaryButton}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    🏠 Main Menu
                </button>
            </div>
        </div>
    );
};
